/**
 * Client-side access to the agent's run log. The board shows the last run so
 * it is obvious at a glance whether the hourly job is alive and what it did —
 * an autonomous process you cannot see is one you cannot trust.
 */

import { AuthExpiredError } from './ims.js';

export interface AgentRun {
  id: string;
  started_at: string;
  finished_at: string | null;
  status: 'running' | 'ok' | 'failed';
  deals_reviewed: number;
  emails_sent: number;
  stage_changes: number;
  detail: unknown;
  error: string | null;
}

export async function listAgentRuns(limit = 10): Promise<AgentRun[]> {
  const res = await fetch(`/api/tasks/agent-runs?limit=${encodeURIComponent(String(limit))}`);
  if (res.status === 401 || res.status === 403) throw new AuthExpiredError();
  if (!res.ok) throw new Error(`Couldn't load the agent's run log (${res.status})`);
  return (await res.json()) as AgentRun[];
}
